export enum CuppingFieldType {
  RadioButton = 1,
  Stars = 2,
  Slider = 3,
  RoastLevel = 4,
  Checkbox = 5,
}
